import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { SplitText } from 'gsap/SplitText.js';

gsap.registerPlugin(ScrollTrigger, SplitText);

/**
 * @typedef {{}} TextAppearProps
 */

/**
 * TextAppear TextAppear.
 * @augments {Base<TextAppearProps>}
 */
export default class TextAppear extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'TextAppear',
  };

  /**
   *
   */
  mounted() {
    const split = new SplitText(this.$el, { type: 'lines' });

    this.tl = gsap.timeline(
      {
        scrollTrigger: {
          trigger: this.$el,
          scrub: 1,
          start: 'bottom bottom',
          end: '+=100px center',
          once: false,
        },
      }
    );

    split.lines.forEach((target) => {
      this.tl.to(target, {
        backgroundPositionX: 0,
        ease: 'none',
      });
    });
  }
}
